import React from "react"

import {FieldTableCellProps} from "../../../../../render/table/table-cell"
import FieldStatus_TableCellCalculated_NotHovered from "./not-hovered"

// const debug = "FieldStatus_TableCellCalculated"
const debug = false

export default function FieldStatus_TableCellCalculated(props: FieldTableCellProps) {

    const width = props.column.width

    const style : style = _.clone(props.style) || {} // we need clone here because we add width!
    style.width = width

    debug && console.log(debug, "render")

    return (
        <FieldStatus_TableCellCalculated_NotHovered
            className       = {props.className}
            style           = {style}
            listItem        = {props.listItem}
            column          = {props.column}
            field           = {props.field}
        />
    )
}
